<template>
  <div class="header">
    <div class="lf xtName">{{ title }}</div>
    <div class="lf changeRole" v-if="role">
      <template v-if="Object.keys(roles).length >= 2">
        <p class="show" @click="showRoles = !showRoles">{{ role }}</p>
        <ul v-show="showRoles">
          <li @click="changeRole(key)" v-for="(key, value) in roles" :key="key">
            {{ value }}
          </li>
        </ul>
      </template>
      <template v-else>
        <p>{{ role }}</p>
      </template>
    </div>
    <p class="lf" style="margin-left: 100px">
      国家授时中心时间:<span class="time">{{ time }}</span
      ><span class="date">{{ date }}</span>
    </p>
    <div class="rt">
      <span v-if="user">欢迎您：{{ user }}</span>
      <button v-if="user" type="button" @click="loginOut">退出</button>
      <a v-else @click="showCA">驱动下载</a>
    </div>
  </div>
</template>

<script>
import { title } from "@/settings";
import { DateTimeDisplay, listenVisibilityChange, setPreciseInterval } from '@/utils/date-time-display.js';

export default {
  name: "myheader",
  data() {
    return {
      time: "",
      date: "",
      interval: null,
      showRoles: false,
      roles: {},
      role: "",
    };
  },
  computed: {
    user() {
      return localStorage.getItem("user") ? localStorage.getItem("user") : "";
    },
    title() {
      return title;
    },
  },
  methods: {
    getTimestamp() {
      const startTime = +new Date();
      this.$api
        .getGjsssj({})
        .then((res) => {
          if (res?.data?.meta?.success) {
            const elapsed = +new Date() - startTime;
            console.log('接口加载时间（ms）：', elapsed);
            this.dateTimeDisplay.start(res.data.data.gjsssj, elapsed);
          }
        })
        .catch(() => { });
    },

    getGjTime() {
      this.dateTimeDisplay = new DateTimeDisplay({
        callback: (dateTimeStr) => this.time = dateTimeStr
      })

      listenVisibilityChange(
        () => this.getTimestamp(),
        () => this.dateTimeDisplay.stop()
      );

      setPreciseInterval(() => this.getTimestamp(), 10 * 60 * 1000);

      this.getTimestamp();
    },

    checkViChange() {
      // if (!document.hidden) {
      //   //如果浏览器处于禁止状态，则重新获取数据
      //   this.getGjTime();
      // }
    },

    // getGjTime() {
    //   let para = {};
    //   clearInterval(this.interval);
    //   this.interval = null;
    //   this.$api
    //     .getGjsssj(para)
    //     .then((res) => {
    //       if (res.data.meta.success) {
    //         var date = new Date(
    //           this.$moment(res.data.data.gjsssj).format("YYYY/MM/DD HH:mm:ss")
    //         ).getTime();
    //         this.date = this.$moment(date).format("YYYY-MM-DD");
    //         this.time = this.$moment(date).format("HH:mm:ss");
    //         var _this = this;
    //         this.interval = setInterval(function () {
    //           date = date + 1000;
    //           _this.date = _this.$moment(date).format("YYYY-MM-DD");
    //           _this.time = _this.$moment(date).format("HH:mm:ss");
    //         }, 1000);
    //       }
    //     })
    //     .catch(() => {});
    // },
    loginOut() {
      this.$api
        .loginOut()
        .then((res) => {
          if (res.data.meta.success) {
            localStorage.removeItem("role");
            localStorage.removeItem("user");
            sessionStorage.removeItem("lcSteps");
            sessionStorage.removeItem("xmmc");
            localStorage.removeItem("tbtsnr");
            localStorage.removeItem("jgdm");
            sessionStorage.removeItem("bdId");
            sessionStorage.removeItem("kbxmZt");
            sessionStorage.removeItem("searchObj");
            sessionStorage.removeItem("myParam");
            this.$router.push("/login");
          } else {
            this.$message({
              message: res.data.meta.message,
              type: "error",
            });
          }
        })
        .catch(() => {});
    },
    // checkViChange() {
    //   if (!document.hidden) {
    //     //如果浏览器处于禁止状态，则重新获取数据
    //     this.getGjTime();
    //   }
    // },
    //切换角色
    changeRole(id) {
      this.showRoles = false;
      localStorage.setItem("role", id);
      if (this.$route.name == "kbxmList") {
        this.$router.go(0);
      } else {
        this.$router.push("/kbxmList");
        sessionStorage.removeItem("lcSteps");
        sessionStorage.removeItem("xmmc");
        sessionStorage.removeItem("bdId");
        sessionStorage.removeItem("kbxmZt");
      }
    },
    getRoles() {
      let para = {
        username: this.user,
      };
      this.$api
        .changeRyjs(para)
        .then((res) => {
          if (res.data.meta.success) {
            this.roles = res.data.data;
            for (const key in this.roles) {
              if (this.roles.hasOwnProperty.call(this.roles, key)) {
                const value = this.roles[key];
                if (localStorage.getItem("role") == value) this.role = key;
              }
            }
          } else {
            this.$message({
              message: res.data.meta.message,
              type: "error",
            });
          }
        })
        .catch(() => {});
    },
    showCA() {
      document.getElementsByClassName("mask-black-ca")[0].style.display =
        "block";
      document.getElementById("driverDownloadDialog").style.display = "block";
    },
  },
  mounted() {
    if (this.user) {
      this.getRoles();
    }
    this.getGjTime();
    // let _this = this;
    // document.addEventListener("visibilitychange", _this.checkViChange);
  },
  destroyed() {
    // document.removeEventListener("visibilitychange", this.checkViChange);
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="less">
.header {
  padding: 0 30px;
  height: 80px;
  line-height: 80px;
  background: @base-color;
  color: #fff;
  font-size: 16px;
  .role {
    font-weight: bold;
    color: #ffff00;
  }
  p {
    height: 80px;
  }
  .xtName {
    font-size: 26px;
    font-weight: bold;
    background: url("../assets/images/logo_w.png") no-repeat center left;
    padding-left: 55px;
  }
  .changeRole {
    margin-left: 20px;
    position: relative;
    p.show {
      background: url("../assets/images/down2.png") no-repeat center right;
      background-size: 30%;
      padding: 0 20px 0 0;
      cursor: pointer;
    }
    ul {
      box-sizing: content-box;
      position: absolute;
      top: 55px;
      left: -30px;
      background: #fff;
      padding: 10px 0;
      border-radius: 3px;
      min-width: 110px;
      z-index: 99;
      li {
        color: #666;
        text-align: center;
        line-height: 30px;
        cursor: pointer;
      }
    }
  }
  .changeRole:before {
    content: "";
    display: block;
    height: 20px;
    border-left: 1px solid #fff;
    position: absolute;
    top: 30px;
    left: -10px;
  }
  .time {
    font-size: 28px;
    font-weight: bold;
    margin: 0 15px 0 10px;
  }
  .date {
    font-weight: bold;
  }
  button {
    border: 1px solid #fff;
    min-width: 20px;
    height: 38px;
    line-height: 38px;
    color: #fff;
    border-radius: 3px;
    background: transparent;
    font-size: 16px;
    margin-left: 20px;
  }
  a {
    text-decoration: none;
    color: #fff;
  }
}
</style>
